import { z } from 'zod';
import { ArgoMaterialStatusEnum } from '@redviking/argonaut-util/types/db';
import {
    type NodeSocketCfg,
    baseNodeCfgSchema,
} from './base-node';
import { locationSchema } from '../../location.deployParam';

export const importMaterialNodeCfgSchema = baseNodeCfgSchema.extend({
    controlValues: z.object({
        allowGet: z.boolean().default(false),
        location: locationSchema,
        status: z.nativeEnum(ArgoMaterialStatusEnum),
    }),
    kind: z.literal('importMaterial'),
});
export type ImportMaterialNodeCfgSchema = z.infer<typeof importMaterialNodeCfgSchema>;

export const importMaterialNodeSocketCfg = {
    controlSockets: {
        inputs: () => ({ trigger: 'event' }),
        outputs: () => ({ next: 'event' }),
    },
    dataSockets: {
        inputs: () => ({ modelNumber: 'string', serialNumber: 'string', workOrderId: 'string' }),
        outputs: () => ({ materialId: 'string' }),
    },
} satisfies NodeSocketCfg<ImportMaterialNodeCfgSchema>;
